/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardPaymentResultTopErrorViewModel } from "../types/CreditCardPaymentResultTopErrorViewModel.ts";

export const creditCardPaymentResultTopErrorViewModelSchema = z.object({
  status: z.string().nullish(),
  count: z.optional(z.number().int()),
}) as unknown as ToZod<CreditCardPaymentResultTopErrorViewModel>;
